import { z } from "zod";

export const AccountUserSchema = z.object({
  id: z.string(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
});

export type AccountUser = z.infer<typeof AccountUserSchema>;
